// Quick Setup on an existing venue (src/modules/venue-port): edit its structure, then save.
import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { VenueSetupRoute } from '../modules/venue-port/tkt/VenueRoutes';
import { venueNav } from '../modules/venue-port/tkt/venueNav';

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

export const Route = createFileRoute('/venues/$id/setup')({
  validateSearch: (s: Record<string, unknown>): { phase?: string; space?: string } => ({ phase: str(s.phase), space: str(s.space) }),
  component: function VenueSetup() {
    const { id } = Route.useParams();
    const search = Route.useSearch();
    const nav = venueNav(useNavigate(), '/venues/$id/setup', { id });
    return <VenueSetupRoute venueId={id} search={search} nav={nav} />;
  },
});
